export default "__VITE_ASSET__05ad5d16__"